import ArticleParagraph from "components/ArticleParagraph";
import { useGetContentData } from "hooks";
import RootLayout from "layouts/RootLayout";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { liff } from "@line/liff";

const ContentPage = () => {
  const { uuid } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation(["edu", "common"]);
  const mtNotice = t("mtNotice");
  const { contentData } = useGetContentData(uuid);

  const handleGoBack = () => {
    if (contentData?.backLink) {
      // 如果有設定 backLink，導航到指定頁面
      navigate(contentData.backLink);
    } else {
      // 如果沒有設定 backLink，關閉 LINE WebView 視窗
      try {
        if (typeof liff !== 'undefined' && liff.closeWindow) {
          liff.closeWindow();
        } else {
          // Fallback: 如果不是 LINE 環境，使用瀏覽器返回
          window.close();
        }
      } catch (error) {
        console.log('無法關閉 LINE WebView，使用瀏覽器返回:', error);
        navigate(-1);
      }
    }
  };

  // 判斷是否顯示回上頁按鈕
  const shouldShowBackButton = () => {
    // 有設定 backLink 就顯示
    if (contentData?.backLink) {
      return true;
    }
    // 沒有 backLink 但在 LIFF 環境中也顯示（可以關閉視窗）
    try {
      return typeof liff !== 'undefined' && liff.closeWindow;
    } catch {
      return false;
    }
  };

  if (!contentData) return null;

  return (
    <RootLayout title={contentData.title}>
      <div className="px-8 pt-7">
        {mtNotice && (
          <div className="mb-3 px-3 py-2 text-sm text-[#b8860b] bg-[#fff8e1] border border-[#ffe7a3] rounded-md">
            {mtNotice}
          </div>
        )}
        {shouldShowBackButton() && (
          <div
            className="pb-4 flex items-center flex-nowrap cursor-pointer"
            onClick={handleGoBack}
          >
            <span className="mr-2">
              <img src="/img/vector.svg" alt="" />
            </span>
            <span className="text-xl text-[#555555]">{t("common:nav.back")}</span>
          </div>
        )}
        <article className="pb-16">
          <header className="py-2.5 border-b-[1px] border-b-[#D0D0D0]">
            <h1 className="text-2xl mb-2">{contentData.title}</h1>
            <time className="text-[#00000099]">{contentData.date}</time>
          </header>
          <div className="mt-2 space-y-6 text-[#000000E6] text-lg tracking-wider">
            {contentData.paragraph.map((p, index) => (
              <ArticleParagraph key={index} {...p} />
            ))}
          </div>
        </article>
        {shouldShowBackButton() && (
          <div
            className="pb-4 flex items-center flex-nowrap cursor-pointer"
            onClick={handleGoBack}
          >
            <span className="mr-2">
              <img src="/img/vector.svg" alt="" />
            </span>
            <span className="text-xl text-[#555555]">{t("common:nav.back")}</span>
          </div>
        )}
      </div>
    </RootLayout>
  );
};

export default ContentPage;